import React from 'react';
import PropTypes from 'prop-types';
import { ConditionalLink, Component } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';

import { isInternalURL } from '@plone/volto/helpers/Url/Url';

const SummaryTemplate = ({ items, linkTitle, linkHref, isEditMode }) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkTitle || href}</a>;
  }

  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear());

    return day + "." + month + "." + year;
  }

  //console.log(items);

  //COLUMNS SYSTEM EINBAUEN

  return (
    <>
      <div className="items news-wrapper">
        {items.map((item) => (
          <div className="listing-item" key={item['@id']}>
            <div className="listing-body">

              <ConditionalLink item={item} condition={!isEditMode}>
                <div className="news-row columns-view">
                  <div className='ui twelve column grid column-grid'>

                    <div className='three wide computer twelve wide mobile four wide tablet column column-blocks-wrapper img-wrapper'>
                      <Component componentName="PreviewImage" item={item} alt="" />
                    </div>
                    <div className='two wide computer twelve wide mobile four wide tablet column column-blocks-wrapper'>

                      <h3>{item.title ? item.title : item.id}</h3>
                    </div>
                    <div className='seven wide computer twelve wide mobile four wide tablet column column-blocks-wrapper'>

                      <p>{item.description}</p>
                    </div>
                  </div>
                </div>
              </ConditionalLink>
            </div>
          </div>

        ))}
      </div>

      {link && <div className="footer">{link}</div>}
    </>
  );
};

SummaryTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default SummaryTemplate;
